import React, {useEffect, useMemo} from "react";
import {Box,
        createStyles,
        IconButton,
        makeStyles,
        Theme,
        Typography,
        LinearProgress,
      } from "@material-ui/core";
import MapRoundedIcon from "@material-ui/icons/MapRounded";
import EventSeatRoundedIcon from "@material-ui/icons//EventSeatRounded";
import {useDispatch, useSelector} from "react-redux";
import {FormattedDate} from "react-intl";
import {AgendaElement, AgendaElementType, SeatedThinkTank, SeatedThinkTankRealTable,} from "../../models/models";
import Config from "../../config";
import QRCode from "qrcode.react";
import {retrieveRegistrations, selectRegistration, selectRegistrations,} from "../registrations/registrationsSlice";
import {retrieveProfile, selectProfile} from "../registrations/registrationsSlice";
import {retrieveEvent, selectEvent} from "./eventSlice";
import {selectThinkTankSeatingIsFetching, retrieveThinkTankSeating, selectThinkTankSeatings, selectThinkTanks, selectThinkTankRealTables} from "./thinkTankSeatingSlice";
import {selectToken} from "../authentication/authenticationSlice";
import {getClosestAgendaElementToDate} from "../../utils/agenda";
import {retrieveDinnerSeating, selectDinnerSeating, selectDinnerSeatingIsFetching} from "./dinnerSeatingSlice";
import {FirstLoginFlowDialog} from "../firstLoginFlow/FirstLoginFlowDialog";
import {SponsorBanner} from "../../components/sponsorBanner/SponsorBanner";
import {retrieveBranding, selectBranding} from "../badge/brandingSlice";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      backgroundColor: theme.palette.background.default,
      overflow: "auto",
    },
    focusArea: {
      backgroundColor: theme.palette.primary.main,
      height: 200,
      padding: 20,
    },
    row: {
      display: "flex",
      alignItems: "center",
      marginBottom: 20,
    },
    indicator: {
      height: 10,
      width: 10,
      borderRadius: 5,
      backgroundColor: theme.palette.primary.main,
      marginRight: 10,
    },
    name: {
      fontWeight: "bold",
    },
  })
);

export const Badge = () => {
  const classes = useStyles();

  const dispatch = useDispatch();

  const authToken = useSelector(selectToken);

  const event = useSelector(selectEvent);
  const registration = useSelector(selectRegistration(Config.getInstance().getRegistrationID()));
  const registrations = useSelector(selectRegistrations);
  const profile = useSelector(selectProfile(Config.getInstance().getRegistrationID()));
  const seatedRegistrations = useSelector(selectThinkTankSeatings);
  const thinkTankSeatingIsFetching = useSelector(selectThinkTankSeatingIsFetching);
  const brandingPartners = useSelector(selectBranding);

  useEffect(() => {
    if (authToken) {
      dispatch(retrieveEvent(authToken, Config.getInstance().getEventID()));
      dispatch(retrieveThinkTankSeating(authToken, Config.getInstance().getEventID()));
      dispatch(retrieveRegistrations(authToken, Config.getInstance().getEventID()));
      dispatch(retrieveProfile(authToken,Config.getInstance().getEventID(),Config.getInstance().getRegistrationID()));
      dispatch(retrieveBranding(Config.getInstance().getPublicToken(), Config.getInstance().getEventID()));
    }
  }, [authToken]); // eslint-disable-line react-hooks/exhaustive-deps


  const thinkTankSeatings: ThinkTankSeating[] = useMemo(() => {
    const userSeatings = seatedRegistrations.filter(
      (registration) =>
        registration.profile.id === Config.getInstance().getRegistrationID()
    );
    return userSeatings.sort((a: ThinKTankSeating, b: ThinkTankSeating) =>
      a.round > b.round ? 1 : a.round < b.round ? -1 : 0
    );
  }, [seatedRegistrations.length]); // eslint-disable-line react-hooks/exhaustive-deps

  const isLoading = thinkTankSeatingIsFetching;

  const getThinkTankDetail = (roundIndex: number) => {
    let tableNumber = "-"
    if(thinkTankSeatings[roundIndex] &&
       thinkTankSeatings[roundIndex].thinkTankRealTable){
         tableNumber=thinkTankSeatings[roundIndex].thinkTankRealTable.tableNumber
       }


    return (
      <Box style={{ padding: 20 }}>
        {thinkTankSeatings.length > 0 &&
         <>
            <Typography
              variant="h6"
              color="textPrimary"
              style={{ fontWeight: "bold" }}
            >
              {thinkTankSeatings[roundIndex]?.thinkTankRealTable?.thinkTankTable === null ? "" : "Tisch " + tableNumber}
            </Typography>
          </>
        }
      </Box>
    );
  }

/*

  //jede Runde 5 Minuten (= 6 Runden)
  const agendaNetworkingA: AgendaElement[] = [
    new AgendaElement(
      "1",
      AgendaElementType.ThinkTankRound,
      "Rahmenprogramm",
      <Box>
        <Typography color="textPrimary">Speed2Connect</Typography>
        <Typography color="textSecondary">Allgemeine Anfragen & Problemstellungen</Typography>
        <Typography color="textSecondary">Logistik</Typography>
        <Typography color="textSecondary">Rückstandsanalytik</Typography>
        <Typography color="textSecondary">Mikrobiologische Untersuchungen</Typography>
        <Typography color="textSecondary">Allgemeine chemische Analysen</Typography>
        <Typography color="textSecondary">Hygiene- und Qualitätssicherungssysteme (z.B. IFS, BRC, HACCP)</Typography>
        <Typography color="textSecondary">Migrationsanalysen & Verpackungsprüfungen</Typography>
      </Box>,
      "2021-11-03T13:50:00.000Z",
      "2021-11-03T13:57:30.000Z",
      getThinkTankDetail(0)
    ),
    new AgendaElement(
      "1",
      AgendaElementType.ThinkTankRound,
      "Rahmenprogramm",
      <Box>
        <Typography color="textPrimary">Speed2Connect</Typography>
        <Typography color="textSecondary">Allgemeine Anfragen & Problemstellungen</Typography>
        <Typography color="textSecondary">Logistik</Typography>
        <Typography color="textSecondary">Rückstandsanalytik</Typography>
        <Typography color="textSecondary">Mikrobiologische Untersuchungen</Typography>
        <Typography color="textSecondary">Allgemeine chemische Analysen</Typography>
        <Typography color="textSecondary">Hygiene- und Qualitätssicherungssysteme (z.B. IFS, BRC, HACCP)</Typography>
        <Typography color="textSecondary">Migrationsanalysen & Verpackungsprüfungen</Typography>
      </Box>,
      "2021-11-03T13:57:30.000Z",
      "2021-11-03T14:05:00.000Z",
      getThinkTankDetail(1)
    ),
    new AgendaElement(
      "1",
      AgendaElementType.ThinkTankRound,
      "Rahmenprogramm",
      <Box>
        <Typography color="textPrimary">Speed2Connect</Typography>
        <Typography color="textSecondary">Allgemeine Anfragen & Problemstellungen</Typography>
        <Typography color="textSecondary">Logistik</Typography>
        <Typography color="textSecondary">Rückstandsanalytik</Typography>
        <Typography color="textSecondary">Mikrobiologische Untersuchungen</Typography>
        <Typography color="textSecondary">Allgemeine chemische Analysen</Typography>
        <Typography color="textSecondary">Hygiene- und Qualitätssicherungssysteme (z.B. IFS, BRC, HACCP)</Typography>
        <Typography color="textSecondary">Migrationsanalysen & Verpackungsprüfungen</Typography>
      </Box>,
      "2021-11-03T14:05:00.000Z",
      "2021-11-03T14:12:30.000Z",
      getThinkTankDetail(2)
    ),
    new AgendaElement(
      "1",
      AgendaElementType.ThinkTankRound,
      "Rahmenprogramm",
      <Box>
        <Typography color="textPrimary">Speed2Connect</Typography>
        <Typography color="textSecondary">Allgemeine Anfragen & Problemstellungen</Typography>
        <Typography color="textSecondary">Logistik</Typography>
        <Typography color="textSecondary">Rückstandsanalytik</Typography>
        <Typography color="textSecondary">Mikrobiologische Untersuchungen</Typography>
        <Typography color="textSecondary">Allgemeine chemische Analysen</Typography>
        <Typography color="textSecondary">Hygiene- und Qualitätssicherungssysteme (z.B. IFS, BRC, HACCP)</Typography>
        <Typography color="textSecondary">Migrationsanalysen & Verpackungsprüfungen</Typography>
      </Box>,
      "2021-11-03T14:12:30.000Z",
      "2021-11-03T14:20:00.000Z",
      getThinkTankDetail(3)
    ),
    new AgendaElement(
      "1",
      AgendaElementType.ThinkTankRound,
      "Rahmenprogramm",
      <Box>
        <Typography color="textPrimary">Speed2Connect</Typography>
        <Typography color="textSecondary">Allgemeine Anfragen & Problemstellungen</Typography>
        <Typography color="textSecondary">Logistik</Typography>
        <Typography color="textSecondary">Rückstandsanalytik</Typography>
        <Typography color="textSecondary">Mikrobiologische Untersuchungen</Typography>
        <Typography color="textSecondary">Allgemeine chemische Analysen</Typography>
        <Typography color="textSecondary">Hygiene- und Qualitätssicherungssysteme (z.B. IFS, BRC, HACCP)</Typography>
        <Typography color="textSecondary">Migrationsanalysen & Verpackungsprüfungen</Typography>
      </Box>,
      "2021-11-03T14:20:00.000Z",
      "2021-11-03T14:27:30.000Z",
      getThinkTankDetail(4)
    ),
    new AgendaElement(
      "1",
      AgendaElementType.ThinkTankRound,
      "Rahmenprogramm",
      <Box>
        <Typography color="textPrimary">Speed2Connect</Typography>
        <Typography color="textSecondary">Allgemeine Anfragen & Problemstellungen</Typography>
        <Typography color="textSecondary">Logistik</Typography>
        <Typography color="textSecondary">Rückstandsanalytik</Typography>
        <Typography color="textSecondary">Mikrobiologische Untersuchungen</Typography>
        <Typography color="textSecondary">Allgemeine chemische Analysen</Typography>
        <Typography color="textSecondary">Hygiene- und Qualitätssicherungssysteme (z.B. IFS, BRC, HACCP)</Typography>
        <Typography color="textSecondary">Migrationsanalysen & Verpackungsprüfungen</Typography>
      </Box>,
      "2021-11-03T14:27:30.000Z",
      "2021-11-03T14:35:00.000Z",
      getThinkTankDetail(5)
    ),
    new AgendaElement(
      "1",
      AgendaElementType.Other,
      "Rahmenprogramm",
      "Kaffee Pause",
      "2021-11-03T14:35:00.000Z",
      "2021-11-03T14:55:00.000Z"
    ),
    new AgendaElement(
      "1",
      AgendaElementType.Other,
      "Rahmenprogramm",
      "VR - Station",
      "2021-11-03T14:55:00.000Z",
      "2021-11-03T15:40:00.000Z"
    )
  ]


  const agendaNetworkingB: AgendaElement[] = [
    new AgendaElement(
      "1",
      AgendaElementType.Other,
      "Rahmenprogramm",
      "VR - Station",
      "2021-11-03T13:50:00.000Z",
      "2021-11-03T14:35:00.000Z"
    ),
    new AgendaElement(
      "1",
      AgendaElementType.Other,
      "Rahmenprogramm",
      "Kaffee Pause",
      "2021-11-03T14:35:00.000Z",
      "2021-11-03T14:55:00.000Z"
    ),

    new AgendaElement(
      "1",
      AgendaElementType.ThinkTankRound,
      "Rahmenprogramm",
      <Box>
        <Typography color="textPrimary">Speed2Connect</Typography>
        <Typography color="textSecondary">Allgemeine Anfragen & Problemstellungen</Typography>
        <Typography color="textSecondary">Logistik</Typography>
        <Typography color="textSecondary">Rückstandsanalytik</Typography>
        <Typography color="textSecondary">Mikrobiologische Untersuchungen</Typography>
        <Typography color="textSecondary">Allgemeine chemische Analysen</Typography>
        <Typography color="textSecondary">Hygiene- und Qualitätssicherungssysteme (z.B. IFS, BRC, HACCP)</Typography>
        <Typography color="textSecondary">Migrationsanalysen & Verpackungsprüfungen</Typography>
      </Box>,
      "2021-11-03T14:55:00.000Z",
      "2021-11-03T15:02:30.000Z",
      getThinkTankDetail(0)
    ),
    new AgendaElement(
      "1",
      AgendaElementType.ThinkTankRound,
      "Rahmenprogramm",
      <Box>
        <Typography color="textPrimary">Speed2Connect</Typography>
        <Typography color="textSecondary">Allgemeine Anfragen & Problemstellungen</Typography>
        <Typography color="textSecondary">Logistik</Typography>
        <Typography color="textSecondary">Rückstandsanalytik</Typography>
        <Typography color="textSecondary">Mikrobiologische Untersuchungen</Typography>
        <Typography color="textSecondary">Allgemeine chemische Analysen</Typography>
        <Typography color="textSecondary">Hygiene- und Qualitätssicherungssysteme (z.B. IFS, BRC, HACCP)</Typography>
        <Typography color="textSecondary">Migrationsanalysen & Verpackungsprüfungen</Typography>
      </Box>,
      "2021-11-03T15:02:30.000Z",
      "2021-11-03T15:10:00.000Z",
      getThinkTankDetail(1)
    ),
    new AgendaElement(
      "1",
      AgendaElementType.ThinkTankRound,
      "Rahmenprogramm",
      <Box>
        <Typography color="textPrimary">Speed2Connect</Typography>
        <Typography color="textSecondary">Allgemeine Anfragen & Problemstellungen</Typography>
        <Typography color="textSecondary">Logistik</Typography>
        <Typography color="textSecondary">Rückstandsanalytik</Typography>
        <Typography color="textSecondary">Mikrobiologische Untersuchungen</Typography>
        <Typography color="textSecondary">Allgemeine chemische Analysen</Typography>
        <Typography color="textSecondary">Hygiene- und Qualitätssicherungssysteme (z.B. IFS, BRC, HACCP)</Typography>
        <Typography color="textSecondary">Migrationsanalysen & Verpackungsprüfungen</Typography>
      </Box>,
      "2021-11-03T15:10:00.000Z",
      "2021-11-03T15:17:30.000Z",
      getThinkTankDetail(2)
    ),
    new AgendaElement(
      "1",
      AgendaElementType.ThinkTankRound,
      "Rahmenprogramm",
      <Box>
        <Typography color="textPrimary">Speed2Connect</Typography>
        <Typography color="textSecondary">Allgemeine Anfragen & Problemstellungen</Typography>
        <Typography color="textSecondary">Logistik</Typography>
        <Typography color="textSecondary">Rückstandsanalytik</Typography>
        <Typography color="textSecondary">Mikrobiologische Untersuchungen</Typography>
        <Typography color="textSecondary">Allgemeine chemische Analysen</Typography>
        <Typography color="textSecondary">Hygiene- und Qualitätssicherungssysteme (z.B. IFS, BRC, HACCP)</Typography>
        <Typography color="textSecondary">Migrationsanalysen & Verpackungsprüfungen</Typography>
      </Box>,
      "2021-11-03T15:17:30.000Z",
      "2021-11-03T15:25:00.000Z",
      getThinkTankDetail(3)
    ),
    new AgendaElement(
      "1",
      AgendaElementType.ThinkTankRound,
      "Rahmenprogramm",
      <Box>
        <Typography color="textPrimary">Speed2Connect</Typography>
        <Typography color="textSecondary">Allgemeine Anfragen & Problemstellungen</Typography>
        <Typography color="textSecondary">Logistik</Typography>
        <Typography color="textSecondary">Rückstandsanalytik</Typography>
        <Typography color="textSecondary">Mikrobiologische Untersuchungen</Typography>
        <Typography color="textSecondary">Allgemeine chemische Analysen</Typography>
        <Typography color="textSecondary">Hygiene- und Qualitätssicherungssysteme (z.B. IFS, BRC, HACCP)</Typography>
        <Typography color="textSecondary">Migrationsanalysen & Verpackungsprüfungen</Typography>
      </Box>,
      "2021-11-03T15:25:00.000Z",
      "2021-11-03T15:32:30.000Z",
      getThinkTankDetail(4)
    ),
    new AgendaElement(
      "1",
      AgendaElementType.ThinkTankRound,
      "Rahmenprogramm",
      <Box>
        <Typography color="textPrimary">Speed2Connect</Typography>
        <Typography color="textSecondary">Allgemeine Anfragen & Problemstellungen</Typography>
        <Typography color="textSecondary">Logistik</Typography>
        <Typography color="textSecondary">Rückstandsanalytik</Typography>
        <Typography color="textSecondary">Mikrobiologische Untersuchungen</Typography>
        <Typography color="textSecondary">Allgemeine chemische Analysen</Typography>
        <Typography color="textSecondary">Hygiene- und Qualitätssicherungssysteme (z.B. IFS, BRC, HACCP)</Typography>
        <Typography color="textSecondary">Migrationsanalysen & Verpackungsprüfungen</Typography>
      </Box>,
      "2021-11-03T15:32:30.000Z",
      "2021-11-03T15:40:00.000Z",
      getThinkTankDetail(5)
    )
  ]
*/

/*

  const agendaLaboratory: AgendaElement[] = [
      new AgendaElement("1",
                        AgendaElementType.Other,
                        "Labor Besichtigung",
                        "Shuttle zum Labor & Einführung im Labor",
                        "2021-11-03T13:50:00.000Z",
                        "2021-11-03T14:10:00.000Z"),
      new AgendaElement("1",
                        AgendaElementType.Other,
                        "Labor Besichtigung",
                        "Besichtigung & praktische Demonstrationen",
                        "2021-11-03T14:10:00.000Z",
                        "2021-11-03T15:10:00.000Z"),
      new AgendaElement("1",
                        AgendaElementType.Other,
                        "Labor Besichtigung",
                        "Shuttle zurück zum Tagungsort",
                        "2021-11-03T15:10:00.000Z",
                        "2021-11-03T15:40:00.000Z")
  ]

  const agendaEmpty: AgendaElement[] = [
      new AgendaElement("1",
                        AgendaElementType.Other,
                        "Kein Nachmittagsprogramm ausgewählt",
                        "Bitte wenden Sie sich an die Event Organisation",
                        "2021-11-03T13:50:00.000Z",
                        "2021-11-03T15:40:00.000Z")
  ]


  const dynamicAgendaElements = () => {
    if(registration.eventOption === 'bilacon-laboratory'){
      return agendaLaboratory;
    } else if(registration.eventOption === 'bilacon-networking' &&
              registration.eventGroup === 1){
      return agendaNetworkingA;
    } else if(registration.eventOption === 'bilacon-networking' &&
              registration.eventGroup === 2){
      return agendaNetworkingB;
    } else{
      return agendaEmpty
    }
  }
  */

  /*
  const agendaKeynotes: AgendaElement[] = [
    new AgendaElement(
      "1",
      AgendaElementType.KeynoteRound,
      "Keynote 1 - Dr. Andreas Müller",
      "\"Aus dem Nähkästchen eines Food Fraud Ermittlers\" - Dr. Andreas Müller",
      "2021-11-03T08:45:00.000Z",
      "2021-11-03T09:30:00.000Z"
    ),
    new AgendaElement(
      "1",
      AgendaElementType.KeynoteRound,
      "Keynote 2 - Roy Sperling",
      "\"20 Jahre Analytik - Wo geht die Reise hin\" - Roy Sperling",
      "2021-11-03T09:30:00.000Z",
      "2021-11-03T10:15:00.000Z"
    ),
    new AgendaElement(
      "1",
      AgendaElementType.KeynoteRound,
      "Keynote 3 - Dirk Lorenz",
      "\"Bewertung von Untersuchungsergebnissen von Listeria monocytogenes\" - Dirk Lorenz",
      "2021-11-03T10:30:00.000Z",
      "2021-11-03T11:15:00.000Z"
    ),
    new AgendaElement(
      "1",
      AgendaElementType.KeynoteRound,
      "Keynote 4 - Colin Andersen",
      "\"Meldepflicht und Risikomanagement im Lebensmittelbereich\" - Colin Andersen",
      "2021-11-03T12:15:00.000Z",
      "2021-11-03T13:00:00.000Z"
    ),
    new AgendaElement(
      "1",
      AgendaElementType.KeynoteRound,
      "Keynote 5 - Dr. Ulrich Nehring",
      "\"Lebensmittel sicher und nachhaltig verpacken - wie soll das gehen?\" - Dr. Ulrich Nehring",
      "2021-11-03T13:00:00.000Z",
      "2021-11-03T13:45:00.000Z"
    )
  ];

  const agenda = [...agendaKeynotes, ...dynamicAgendaElements()];
  */

  const agendaKeynotes: AgendaElement[] = [
    new AgendaElement(
      "1",
      AgendaElementType.KeynoteRound,
      "Keynote 1 - Dr. Monika Christlbauer & Simone Schmidt",
      "\"Das Leben riecht besser mit uns - Einblicke in die faszinierende Welt der Aromastoffe\" - Dr. Monika Christlbauer & Simone Schmidt",
      "2021-05-21T09:45:00+02:00",
      "2021-05-21T10:30:00+02:00"
    ),
    new AgendaElement(
      "1",
      AgendaElementType.KeynoteRound,
      "Keynote 2 - Dr. Anna Romanotto",
      "\"klein aber kritisch - Analytik von Mikroplastik um uns herum und erste Ergebnisse\" - Dr. Anna Romanotto",
      "2021-05-21T10:30:00+02:00",
      "2021-05-21T11:15:00+02:00"
    ),
    new AgendaElement(
      "1",
      AgendaElementType.KeynoteRound,
      "Keynote 3 - Paul Andrei",
      "\"Aktuelle Trends in der mikrobiologischen Qualitätskontrolle! Rechtliche Anforderungen, DGHM Empefehlungen & Co.\" - Paul Andrei",
      "2021-05-21T11:30:00+02:00",
      "2021-05-21T12:15:00+02:00"
    ),
    new AgendaElement(
      "1",
      AgendaElementType.KeynoteRound,
      "Keynote 4 - Ariane Cofré",
      "\"Lebensmittelsicherheit im Fokus: Regulatorische Neuigkeiten für Kontaminanten (PFAS, BPA und MOSH/MOAH) mit Einblicken in die Analytik\" - Ariane Cofré",
      "2021-05-21T13:15:00+02:00",
      "2021-05-21T14:00:00+02:00"
    ),
    new AgendaElement(
      "1",
      AgendaElementType.KeynoteRound,
      "Keynote 5 - Dr. Andreas Müller",
      "\"Food Fraud - Wie funktioniert das eigentlich im Täterbetrieb und wer sind die Täter?\" - Dr. Andreas Müller",
      "2021-05-21T14:00:00+02:00",
      "2021-05-21T14:45:00+02:00"
    ),
    new AgendaElement(
      "1",
      AgendaElementType.KeynoteRound,
      "Keynote 6 - Beate Heidorn",
      "\"Audit Ahead! Zwischen Paragraphen, Praxis und Fallstricken\" - Beate Heidorn",
      "2021-05-21T14:45:00+02:00",
      "2021-05-21T15:10:00+02:00"
    )
  ];

const agendaClosing: AgendaElement[] = [
    new AgendaElement(
      "1",
      AgendaElementType.Other,
      "Let's Connect!",
      "Praxisworkshop - Flavor Sticks & Praxisworkshop - Mikroplastik",
      "2021-05-21T15:10:00+02:00",
      "2021-05-21T23:59:00+02:00"
    )
  ];

  const agenda = [...agendaKeynotes, ...agendaClosing];

//debug
//  const testDate = new Date("2022-09-30T19:00:00.000Z");
//  const testDate = new Date("2025-05-15T14:10:00.000Z");
//  console.log('testDate', testDate, event?.eventDate)
//  const testDate = new Date("2025-05-15T23:10:00+02:00");
//  const eventDate = new Date("2025-05-15T14:10:00.000Z");

  const nextRelevantAgendaElement = useMemo(() => {
    return getClosestAgendaElementToDate(
      agenda,
      new Date(),
      new Date(event?.eventDate || "")
//debug
//      testDate,
//      eventDate
    );
  }, [event?.eventDate]); // eslint-disable-line react-hooks/exhaustive-deps


  const getNextUpDescription = (agendaElement: AgendaElement): string => {
    if (agendaElement.type === AgendaElementType.KeynoteRound) {
      return agendaElement.name;
    }
    if (agendaElement.type === AgendaElementType.Other) {
      return agendaElement.name;
    }
    if (agendaElement.type === AgendaElementType.ThinkTankRound) {
      return agendaElement.name;
    }
    return "";
  };

  const getRegistrationTitle = (registration: any) => {
    if(registration?.title && registration?.title === "Title not defined") return ""
    return registration.title
  }

  return (

    <Box className={classes.container}>
       <SponsorBanner
         businessPartners={brandingPartners}
       />

    {/*
      <FirstLoginFlowDialog
           authToken={authToken || ""}
           registrations={registrations}
           profile={profile}
           event={event}
      />
      */}

      <Box style={{ padding: 20 }}>
        <Typography
          variant="h6"
          color="textPrimary"
          align="left"
          style={{ fontWeight: "bold" }}
        >
          {registration?.name}
        </Typography>
        <Typography
          color="textSecondary"
          align="left"
          style={{ fontWeight: "bold" }}
        >
          {getRegistrationTitle(registration)}
        </Typography>
        <Typography color="textSecondary" align="left">
          {registration?.company}
        </Typography>
        <Box style={{ height: 40 }} />
        <Typography color="textPrimary" align="left">
          {event?.name?.split("#")[0].trim()}
        </Typography>
        <Typography color="textSecondary" align="left">
          <FormattedDate value={event?.eventDate} />
        </Typography>
      </Box>
       {isLoading && <LinearProgress color="primary" />}
       {!isLoading &&
      <Box className={classes.focusArea}>
        <Typography color="textSecondary">
          {nextRelevantAgendaElement
            ? getNextUpDescription(nextRelevantAgendaElement)
            : ""}
        </Typography>

        <Box style={{ padding: 20 }}>
        <Typography
            variant="h6"
            color="textPrimary"
            style={{ fontWeight: "bold" }}
          >
            {nextRelevantAgendaElement?.description}
        </Typography>
        {nextRelevantAgendaElement?.detailComponent}
        </Box>
      </Box>
      }
      <Box
        style={{
          paddingTop: 20,
          paddingLeft: 20,
          paddingRight: 20,
          paddingBottom: 40,
        }}
      >
        <Box style={{ display: "flex", alignItems: "center" }}>
          <Box style={{ flex: 1 }}>
            <Typography
              color="textPrimary"
              align="left"
              style={{ fontWeight: "bold" }}
            >
              Event Location
            </Typography>
            <Typography color="textSecondary" align="left">
              {`${event?.venueName}, ${event?.venueStreetAddress1}, ${event?.venuePostalCode} ${event?.venueCity}`}
            </Typography>
          </Box>
          <IconButton
            href={`https://www.google.de/maps/search/${event?.venueName}, ${event?.venueStreetAddress1}, ${event?.venuePostalCode} ${event?.venueCity}`}
            target="_blank"
          >
            <MapRoundedIcon />
          </IconButton>
        </Box>
        <Box style={{ height: 20 }} />
      </Box>
    </Box>
  );
};
